module.exports = __webpack_public_path__ + "img/upload.90b17f08.svg";